import type { ReactNode } from 'react';
import AppSidebar from './AppSidebar';

type AppLayoutProps = {
  subtitle?: string;
  /** Buttons rendered on the right side of the topbar, next to the bell icon. */
  actions?: ReactNode;
  children: ReactNode;
} & (
  | { title: string; headerContent?: undefined }
  | { title?: undefined; headerContent: ReactNode }
);

/**
 * Shared desktop admin shell: fixed 240px (collapsible to 64px) left sidebar
 * + topbar + scrollable content area.
 */
const AppLayout = ({
  title,
  subtitle,
  headerContent,
  actions,
  children,
}: AppLayoutProps) => {
  return (
    <div className="flex h-screen bg-white">
      <AppSidebar />

      <div className="flex-1 flex flex-col bg-lighter overflow-hidden min-w-0">
        <header className="flex items-start justify-between gap-4 px-8 py-5 bg-white border-b border-grey3">
          {headerContent ?? (
            <div>
              <h1 className="text-[26px] font-extrabold text-dark tracking-tight">
                {title}
              </h1>
              {subtitle && (
                <p className="text-sm text-light mt-0.5">{subtitle}</p>
              )}
            </div>
          )}

          <div className="flex items-center gap-3 flex-shrink-0 pt-1">
            {/* Notifications button hidden until notifications are implemented. */}
            {actions}
          </div>
        </header>

        <div className="flex-1 overflow-y-auto px-8 py-6">{children}</div>
      </div>
    </div>
  );
};

export default AppLayout;
